import { render, staticRenderFns } from "./ActionOpenChatNormal.vue?vue&type=template&id=84903e60&"
import script from "./ActionOpenChatNormal.vue?vue&type=script&lang=js&"
export * from "./ActionOpenChatNormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports